import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import React, {useEffect, useMemo, useState, useRef, useCallback} from 'react';
import ServerData from '../../../common/serverData';
import {hideLoader, showLoader} from '../../../store/common/slice';
import {verifyLoggedIn} from '../../../store/auth/actions';
import {calcMonthsTextForSelectBox, shortenText, sortApartmentNumbers, isDemoPartnerAccount} from '../../../common/shared/statelessMethods';
import {StyledDebtList, StyledPopover} from './debtList.styled';
import {OverlayTrigger, Tooltip, Popover, Modal, Container} from 'react-bootstrap';
import Search from '../../../images/search.svg';
import Success from '../../../images/newDesign/success_phone.svg';
import Table from '../../../common/table/TableFunctional';
import {BllinkLogger} from '../../../common/utils/bllink_loggers';
import BllinkUtils from '../../../common/utils/utils';
import ArrowRight from '../../../images/arrow-right.png';
import { constants } from '../../../common/constants/constants';
import WarningLetterNew from './warningLetterNew';
import {getBuildingTitle, getBuildingTitleText} from '../../../store/buildings/actions';
import { isAdminSelector } from '../../../store/auth/selectors';
import {parseApartmentPhone, parseApartmentTenantName} from '../../../store/common/tenantInfo';
import { StyledDebtModal } from './debtList.styled';
import Button from '../../../common/Button';
import {StyledActionsBar} from '../report.styled';
import useBodyClass from '../../../common/hooks/useBodyClassName';
import {CurrencyValue} from "../../../common/currencyValue";
import {NotificationManager} from "react-notifications";
import WarningLetterModal from '../../notifications/WarningLetterModal';
import { createPdfFromHtml } from '../../../common/shared/statelessMethods';
import { fileToBase64 } from '../../../../utils/fileToBase64';
import CommentsModal from '../../comments/CommentsModal';
import { fetchBuildingData } from '../../../store/buildings/actions';
import SendToAllModal from './SendToAllModal';
import DataModal from './DataModal';
import PrintPdfDropdown from '../../../common/export_documents/PrintPdfDropdown';
import {selectCurrentBuildingCurrency} from "../../../store/buildings/selectors";
import ErrorsHandler from "../../../common/errors/handleErrors";

const StringUtils = BllinkUtils.Strings;

export default function DebtList({match}) {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const {buildingID} = match.params;
    const {partnerID} = match.params;

    const accessToken = useSelector((state) => state.auth.accessToken);
    const isAdmin = useSelector(isAdminSelector);
    const titleData = useSelector((state) => state.buildings.titleData);
    const ltr = useSelector((state) => state.common.ltrEnabled);
    const currentBuildingData = useSelector(state => state.buildings.currentBuildingData);

    const [listData, setListData] = useState([]);
    const [filters, setFilters] = useState({});
    const [totalDebt, setTotalDebt] = useState(null);
    const [currency, setCurrency] = useState(selectCurrentBuildingCurrency);
    const [selectedRow, setSelectedRow] = useState({});
    const [title, setTitle] = useState('');
    const [showDataModal, setShowDataModal] = useState(false);
    const [firstModalContainer, setFirstModalContainer] = useState(true);
    const [currentModalData, setCurrentModalData] = useState({
        tenantData: {},
        aptNumber: '',
        building: ''
    });
    const [tenantInfo, setTenantInfo] = useState({
        OwnerEmail: '',
        OwnerName: '',
        OwnerPhone: '',
        RenterEmail: '',
        RenterName: '',
        RenterPhone: '',
    });
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [hiddenColumns, setHiddenColumns] = useState([]);
    const [tableTitle, setTableTitle] = useState('');
    const [tableSubTitle, setTableSubTitle] = useState('');
    const [isPartnerWithMonitoringLoading, setIsPartnerWithMonitoringLoading] = useState(false);
    const [isPartnerWithMonitoring, setIsPartnerWithMonitoring] = useState(null);
    const [partnerStats, setPartnerStats] = useState(null);
    const [sendLetterModal, setSendLetterModal] = useState(false);
    const [letterCheckboxes, setLetterCheckboxes] = useState({
        owner: false,
        renter: false
    });
    const [letterInfo, setLetterInfo] = useState({
        address: '',
        fileBase64: ''
    });
    const [currentAptNumber, setCurrentAptNumber] = useState('');
    const [currentBuilding, setCurrentBuilding] = useState(buildingID || '');
    const [commentsModalOpened, setCommentsModalOpened] = useState(false);
    const [downloadLetter, setDownloadLetter] = useState(false);
    const [showSendToAllModal, setShowSendToAllModal] = useState(false);
    const [apartmentTenantList, setApartmentTenantList] = useState([]);
    const [buildingAddress, setBuildingAddress] = useState();
    const [keysToIgnore, setKeysToIgnore] = useState([]);

    const titleRowPartner = [{
        address: t('reports.buildingName'),
        apartmentNumber: t('reports.apartmentName'),
        tenantName: t('reports.tenantName'),
        tenantPhone: t('reports.tenantPhone'),
        pastPaymentsLeft: t('reports.monthly_debt'),
        openMonthDebtPayments: t('reports.monthly_comment'),
        oneTimeLeft: t('reports.one_time_debt'),
        openOneTimePayments: t('reports.one_time_comment')
    }];

    const titleDebtRow = [{
        apartmentNumber: t('reports.apartmentName'),
        tenantName: t('editBuilding.labels.tenant'),
        tenantPhone: t('reports.tenantPhone'),
        totalDebt: t('reports.total_debt'),
        pastPaymentsLeft: t('reports.monthly_debt'),
        openMonthDebtPayments: t('reports.details'),
        oneTimeLeft: t('reports.special_debt'),
        openOneTimePayments: t('reports.details'),
    }];

    const getPrintableData = useCallback(async (type) => {
        const data = await loadDebtList(0, Number.MAX_SAFE_INTEGER);
        const listData = data.value;
        const parsedRows = JSON.parse(JSON.stringify(listData));
        for (const row of parsedRows) {
            if (partnerID != null) {
                row.address = row.buildingsData.title;
            }
            row.pastPaymentsLeft = type === 'pdf' ? StringUtils.numberWithCommas(row.pastPaymentsLeft) : row.pastPaymentsLeft;
            const text = shortenText(calcMonthsTextForSelectBox(row.openMonthDebtPayments));
            row.openMonthDebtPayments = text?.originalComment || text?.shortComment || text;
            row.oneTimeLeft = type === 'pdf' ? StringUtils.numberWithCommas(row.oneTimeLeft) : row.oneTimeLeft;
            let payments = '';
            if (row.openOneTimePayments) {
                payments = row.openOneTimePayments.reduce((acc, curVal, index) => `${acc} ${curVal.payment_description}${index < row.openOneTimePayments - 1 ? ',' : ''}`, '');
            }
            row.openOneTimePayments = payments;
        }
        return parsedRows;
    }, [])

    useEffect(() => {
        const keys = ['address', 'apartmentNumber', 'tenantName', 'tenantPhone', 'pastPaymentsLeft', 'openMonthDebtPayments', 'oneTimeLeft', 'openOneTimePayments'];
        if (listData && listData.length > 0) {
            const allKeys = Object.keys(listData[0]);
            const keysToIgnore = allKeys?.filter(item => !keys.includes(item));
            setKeysToIgnore(keysToIgnore);
        }
    }, [listData]);

    document.title = partnerID ? t('titles.partner_debt_list') : t('titles.building_debt_list');
    useBodyClass('report');

    let client = new ServerData(null, null, {accessToken: accessToken});

    const getBuildingAddress = async () => {
        if (buildingID && (!currentBuildingData || currentBuildingData.id !== buildingID)) await dispatch(fetchBuildingData({ buildingID }));
        const address = currentBuildingData?.address;
        if (i18n.language === 'he'){
            return address?.full_address;
        }

        return `${address?.countryEN}, ${address?.cityEN}, ${address?.streetEN} ${address?.streetNumber}`;
    }

    useEffect(async () => {
        const address = await getBuildingAddress();
        setBuildingAddress(address);
    }, [currentBuildingData]);

    const openDataModal = (aptNumber, tenantDetails, building, title) => {
        setCurrentModalData({
            tenantData: tenantDetails,
            aptNumber: aptNumber,
            building: building
        });
        setTenantInfo(tenantDetails);
        setCurrentBuilding(building);
        if (title) setBuildingAddress(title)
        setShowDataModal(true);
    };

    const hideDataModal = () => {
        setShowDataModal(false);
        setFirstModalContainer(true);
    };

    const changeModalContainer = () => setFirstModalContainer(false);

    const onInputChange = e => {
        const targ = e.target;
        setTenantInfo({
            ...tenantInfo,
            [targ.name]: targ.value ? targ.value : ''
        })
    };

    const onAptNotesClick = (aptNum, building) => {
        setCurrentAptNumber(aptNum);
        setCurrentBuilding(building);
    };
    useEffect(() => {
        currentAptNumber && currentBuilding && setCommentsModalOpened(true);
    }, [currentAptNumber, currentBuilding]);
    useEffect(() => {
        if (!commentsModalOpened && currentAptNumber) setCurrentAptNumber('');
    }, [commentsModalOpened]);

    const closeModal = () => setCommentsModalOpened(false);

    const columns = useMemo(
        () => [
            {
                Header: t('reports.buildingName'),
                accessor: 'buildingsData.title',
                isVisible: partnerID
            },
            {
                Header: t('reports.apartmentName'),
                accessor: 'apartmentNumber',
                minWidth: 90
            },
            {
                Header: t('reports.tenantName'),
                accessor: 'tenantName',
            },
            {
                Header: t('reports.tenantPhone'),
                accessor: 'tenantPhone',
            },
            {
                Header: t('reports.monthly_debt'),
                accessor: 'pastPaymentsLeft',
                Cell: props => {
                    const text = StringUtils.numberWithCommas(props.value);
                    // using raw value in excel text to enable summing
                    return (<span exceltext={props.value}>{text}</span>);
                }
            },
            {
                Header: t('reports.monthly_comment'),
                accessor: 'openMonthDebtPayments',
                Cell: props => {
                    const text = shortenText(calcMonthsTextForSelectBox(props.value));
                    return (
                        <OverlayTrigger
                            placement="top"
                            overlay={props => (
                                <Tooltip {...props}>
                                    {text.originalComment}
                                </Tooltip>
                            )}
                        >
                            <span exceltext={text.originalComment}>{text.shortComment || text}</span>
                        </OverlayTrigger>
                    );
                },
            },
            {
                Header: t('reports.one_time_debt'),
                accessor: 'oneTimeLeft',
                Cell: props => {
                    const text = StringUtils.numberWithCommas(props.value);
                    // using raw value in excel text to enable summing
                    return (<span exceltext={props.value}>{text}</span>);
                }
            },
            {
                Header: t('reports.one_time_comment'),
                accessor: 'openOneTimePayments',
                Cell: props => {
                    let text = ''
                    if (props.value.length) {
                        text = props.value.reduce((acc, curVal, index) => `${acc} ${curVal.payment_description}${index < props.value.length - 1 ? ',' : ''}`, '');
                    }
                    return (<span exceltext={text}>{text}</span>);
                },
            },
            {
                Header: '',
                accessor: 'sendRequest',
                className: 'send-request',
                Cell: ({ row }) => {
                    const orig = row.original;
                    const building = buildingID || orig.buildingsData?.buildingID;
                    const [showPopover, setShowPopover] = useState(false);
                    return (
                        <OverlayTrigger
                            rootClose
                            show={showPopover}
                            onToggle={() => setShowPopover(!showPopover)}
                            trigger="click"
                            placement="top"
                            overlay={(
                                <StyledPopover>
                                    <Popover.Body>
                                        <div className='link' onClick={() => {
                                                setShowPopover(false);
                                                openDataModal(orig.apartmentNumber, orig.tenantDetails, orig.buildingsData?.buildingID, orig.buildingsData?.title);
                                            }}
                                        >
                                            {t('reports.debtListActions.sendRequest')}
                                        </div>

                                        <div className='link' onClick={() => {
                                                setShowPopover(false);
                                                openSendLetterModal(orig);
                                            }}
                                        >
                                            {t('reports.debtListActions.sendWarningLetter')}
                                        </div>

                                        <div className='link' onClick={() => {
                                                setShowPopover(false);
                                                downloadWarningLetter(orig);
                                            }}
                                        >
                                            {t('reports.debtListActions.downloadWarningLetter')}
                                        </div>

                                        <div className='link' onClick={() => {
                                                setShowPopover(false);
                                                window.open(`/manager-fill-details/${building}`, '_blank');
                                            }}
                                        >
                                            {t('reports.debtListActions.setPayment')}
                                        </div>

                                        <div className='link' onClick={() => {
                                                setShowPopover(false);
                                                onAptNotesClick(orig.apartmentNumber, building);
                                            }}
                                        >
                                            {t('reports.debtListActions.aptNotes')}
                                        </div>
                                    </Popover.Body>
                                </StyledPopover>
                            )
                        }>
                            <div className='tool'>...</div>
                        </OverlayTrigger>
                    )
                }
            },
        ],
        [listData]
    );

    const loadDebtList = async (start, end) => {
        if (!accessToken) {
            try {
                const {payload} = await dispatch(verifyLoggedIn());
                client = new ServerData(null, null, {accessToken: payload.accessToken});
            } catch (e) {
                return;
            }
        }

        if (buildingID) {
            if (!titleData.translationKey) await dispatch(getBuildingTitle({buildingID}));
            const { payload } = await dispatch(getBuildingTitleText({t, buildingID}));
            setTitle(payload);
        } else {
            const partnerData = await getPartnerData();
            setPartnerStats(partnerData?.partnerStats);
            setTitle(partnerData?.partnerStats?.partner?.partnerName);
        }

        let response
        if (isDemoPartnerAccount(partnerID)) {
            const fileName = constants.getDemoPartnerDebtFileName(partnerID);
            const partnerDebt = await import(`../../../common/mocks/data/managers/${fileName}`);
            const {value, totalRecords, totalDebt} = partnerDebt;
            response = { value, totalRecords, totalDebt };
        } else if (buildingID == null) {
            response = await client.managers.debts.getPartnerDebts(partnerID, start, end) ?? { value: [] };
        } else {
            response = await client.managers.debts.getBuildingDebts(buildingID, start, end) ?? { value: [] };
        }

        const apartmentsData = [];
        BllinkLogger.info(`response debt list ${buildingID ? 'building' : 'partner'}`, response);

        response.value = response?.value?.sort((a, b) => sortApartmentNumbers(a.apartmentNumber, b.apartmentNumber));
        response.value?.forEach(item => {
            item.tenantPhone = parseApartmentPhone(item.tenantDetails);
            item.tenantName = parseApartmentTenantName(item.tenantDetails);

            if (partnerID) apartmentsData.push({buildingID: item.buildingID, label: item.apartmentNumber, value: {owner: item.tenantDetails.OwnerEmail, renter: item.tenantDetails.RenterEmail}});
            else apartmentsData.push({label: item.apartmentNumber, value: {owner: item.tenantDetails.OwnerEmail, renter: item.tenantDetails.RenterEmail}});
        });

        setApartmentTenantList(apartmentsData);
        return response;
    };

    const getPartnerData = async () => {
        if (isDemoPartnerAccount(partnerID)) {
            const fileName = constants.getDemoPartnerProfileDataFileName(partnerID);
            const partnerProfileData = await import(`../../../common/mocks/data/managers/${fileName}`);
            return partnerProfileData.value;
        }
        try {
            const data = await client.partners.dashboard.getStats(partnerID);
            return data;
        } catch (e) {
            ErrorsHandler.notifyClientError(e);
            return { partnerStats: {} };
        }
    }


    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const fetchIdRef = useRef(0);

    const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
        const fetchId = ++fetchIdRef.current;
        if (fetchId === fetchIdRef.current) {
            dispatch(showLoader())
            const startRow = pageSize * pageIndex;
            const endRow = startRow + pageSize;
            const data = await loadDebtList(startRow, endRow);
            console.log('fetchData: ', data);
            if (data) {
                setPageCount(Math.ceil(data.totalRecords / pageSize));
                setCurrentPage(pageIndex);
                setListData(data.value);
                setTotalDebt(data.totalDebt);
                setCurrency(data.totalDebt.currency)
            }
            dispatch(hideLoader())
        }
    }, []);

    useEffect(() => {
        setTableTitle(
            <OverlayTrigger
                placement="top"
                overlay={props => (<Tooltip {...props}> {partnerID ? t('reports.total_debt_title_tooltip') : ''}</Tooltip>)}
            >
                <span className='title_wrapper'>
                    {t('reports.total_debt_title')}
                    <CurrencyValue currency={totalDebt?.currency}>
                        {/* CurrencyValue accepts value in cents, but server sends it as shekel/pesos integer value */}
                        {totalDebt?.value * 100 || 0}
                    </CurrencyValue>
                </span>
            </OverlayTrigger>
        );
    }, [currency, totalDebt]);

    useEffect(() => {
        if (partnerID) {
            setTableSubTitle(
                <OverlayTrigger
                    placement="top"
                    overlay={props => (
                        <Tooltip {...props}> {t('reports.total_debt_sub_title_tooltip')}</Tooltip>
                    )}
                >
                <span className='title_wrapper'>
                    {t('reports.total_debt_sub_title_partner')}
                </span>
                </OverlayTrigger>
            );
        }
    }, []);

    const onRowClick = rowData => {
        setSelectedRow(rowData);
    }

    useEffect(() => {
        const columns = [];
        if (partnerID == null) {
            columns.push('buildingsData.title');
        }
        if (currency?.toUpperCase() === 'MXN') {
            // TODO: remove me - I'm a hack
            // NOTE: remove sendRequest for Mexico buildings for now until message templates are not translated
            columns.push('sendRequest');
        }
        setHiddenColumns(columns);
    }, [partnerID, isAdmin, currency]);

    useEffect(() => {
        (async () => {
            if (!isAdmin) return;

            const partnerNumId = partnerStats?.partner?.partnerID;
            if (!partnerNumId) return;
            setIsPartnerWithMonitoringLoading(true);
            const apartmentsMonitoringFeature = await client.operations.getFeature('partnerID', partnerNumId, 'apartmentsMonitoring');
            setIsPartnerWithMonitoring(apartmentsMonitoringFeature?.value === 'true');
            setIsPartnerWithMonitoringLoading(false);
        })()
    }, [partnerStats, isAdmin]);

    const onMonitoringBtnClick = async () => {
        try {
            const partnerNumId = partnerStats?.partner?.partnerID;
            if (!partnerNumId) return;
            setIsPartnerWithMonitoringLoading(true);
            const newValue = isPartnerWithMonitoring ? 'false' : 'true';
            const result = await client.operations.setFeature('partnerID', partnerNumId, 'apartmentsMonitoring', newValue);
            setIsPartnerWithMonitoring(result?.value === 'true');
            setIsPartnerWithMonitoringLoading(false);
            if (isPartnerWithMonitoring) {
                NotificationManager.success(t('monitoring.activeMonitoring.successfullyAllStarted'));
            } else {
                NotificationManager.success(t('monitoring.activeMonitoring.successfullyAllStopped'));
            }
        } catch (e) {
            setIsPartnerWithMonitoringLoading(false);
            NotificationManager.error(t('monitoring.activeMonitoring.somethingWentWrong'));
        }
    }

    const switchMonitoringTitle = isPartnerWithMonitoring ? t('monitoring.activeMonitoring.btns.stopMonitoring') : t('monitoring.activeMonitoring.btns.startMonitoring');

    const openSendLetterModal = row => {
        setSelectedRow(row);
        setSendLetterModal(true);
        if (!buildingID) setCurrentBuilding(row.buildingsData.buildingInternal)
    };

    const hideSendLetterModal = () => {
        setSendLetterModal(false);
        setLetterCheckboxes({
            owner: false,
            renter: false
        });
        setSelectedRow({});
    }

    const getWarningLetter = async (letterContainer, address) => {
        dispatch(showLoader());

        const file = await createPdfFromHtml(letterContainer, '', {save: false, ignoreLastPage: false});
        const fileBase64 = await fileToBase64(file);
        setLetterInfo({
            address,
            fileBase64
        });

        dispatch(hideLoader());
    }

    const sendWarningLetterFromModal = async () => {
        dispatch(showLoader());
        const { address, fileBase64 } = letterInfo;
        const fileName = `${t('letter.fileName')}_${address}_${selectedRow.apartmentNumber}.pdf`;
        const paymentLink = `${constants.frontendUrl}/${constants.pages.paymentSelectionUrl}/${currentBuilding}/${selectedRow.apartmentNumber}`;
        const { owner, renter } = letterCheckboxes;
        const toOwner = owner;
        const toRenter = renter;
        await client.managers.operations.sendWarningLetter(currentBuilding, selectedRow.apartmentNumber, paymentLink, 'application/pdf', fileName, fileBase64, toOwner, toRenter);
        setSelectedRow({});
        dispatch(hideLoader());

        hideSendLetterModal();
    }

    const downloadWarningLetter = row => {
        setSelectedRow(row);
        setDownloadLetter(true);
    };

    const onSendAllModalHide = () => setShowSendToAllModal(false);

    return (
        <StyledDebtList className={buildingID ? 'building-debt' : ''} ltr={ltr}>
            {
                partnerID && (
                    <>
                        <div className='title-wrapper'>
                            <div className="back-link mt-2" data-testid='back-link'>
                                <Link to={`/${constants.pages.buildingManagerCompanyProfileUrl}/${partnerID}`}>
                                    <img alt='return_to_details' src={ArrowRight} />
                                    <span>{t('reports.back_to_dashboard')}</span>
                                </Link>
                            </div>

                            <PrintPdfDropdown
                                pdfIframe
                                pdfSettings={{ chunkSize: 18, orientation: 'l' }}
                                xlsSettings={{ columnTypes: [{ index: 4, type: 'Number' }, { index: 6, type: 'Number' }] }}
                                buildingID={buildingID}
                                partnerID={partnerID}
                                partnerName={title}
                                eventLabel={'partnerDebtList'}
                                titleString={t('reports.partner_debt_list')}
                                excelTitle={t('reports.partner_debt_list')}
                                reportName={t('reports.partner_debt_title')}
                                rows={getPrintableData}
                                titleRow={titleRowPartner}
                                ignoreColumns={keysToIgnore}
                            />
                        </div>

                        <h1 className='page-title text-only centered mt-4 mb-0'>
                            <span>{t('reports.partner_debt_title')}</span>
                            <span className='building-title'>{title}</span>
                        </h1>
                    </>
                )
            }
            {
                buildingID && (
                    <div className='title-wrapper'>
                        <h1 className='page-title'>
                            <span>{t('reports.building_debt_title')}</span>
                            <span className='building-title'>{title}</span>
                        </h1>

                        <PrintPdfDropdown
                            pdfIframe
                            pdfSettings={{ chunkSize: 18, orientation: 'l' }}
                            xlsSettings={{ columnTypes: [{ index: 4, type: 'Number' }, { index: 6, type: 'Number' }] }}
                            buildingID={buildingID}
                            partnerID={partnerID}
                            partnerName={title}
                            eventLabel='buildingDebtList'
                            titleString={t('reports.building_debt_list')}
                            excelTitle={t('reports.building_debt_list')}
                            reportName={t('reports.building_debt_title')}
                            rows={getPrintableData}
                            titleRow={titleDebtRow}
                            ignoreColumns={keysToIgnore}
                        />
                    </div>
                )
            }
            <StyledActionsBar className={'toolbar align-items-center'}>
                <div className="control-with-icon search actions-toolbar-search">
                    <input
                        type="text"
                        className="form-control bllink-input-border"
                        name="search"
                        onChange={e => setFilters({
                            global: e.target.value
                        })}
                    />
                    <img src={Search} alt={t('search.search')} />
                </div>
                <div className="">
                    <button
                        className={'bllink-button send-all-button'}
                        onClick={() => setShowSendToAllModal(true)}
                    >
                        {t('reports.paymentRequestPopUp.sendAll')}
                    </button>
                </div>
                {isAdmin && partnerStats && <div className="actions-button">
                    <Button
                        onClick={onMonitoringBtnClick}
                        disabled={isPartnerWithMonitoringLoading}
                    >
                        {switchMonitoringTitle}
                    </Button>
                </div>}
            </StyledActionsBar>
            <div>
                <Table
                    buildingId={buildingID}
                    columns={columns}
                    data={listData}
                    filters={filters}
                    hiddenColumns={hiddenColumns}
                    tableTitle={tableTitle}
                    tableSubtitle={tableSubTitle}
                    paginationOptions={{
                        fetchData: fetchData,
                        pageCount: pageCount,
                        currentPage: currentPage
                    }}
                    onRowClick={onRowClick}
                />
            </div>

            <DataModal
                showDataModal={showDataModal}
                hideDataModal={hideDataModal}
                firstModalContainer={firstModalContainer}
                changeModalContainer={changeModalContainer}
                tenantInfo={tenantInfo}
                onInputChange={onInputChange}
                buildingID={currentBuilding}
                setShowSuccessModal={setShowSuccessModal}
                currentModalData={currentModalData}
                buildingAddress={buildingAddress}
                currency={currency}
            />

            <StyledDebtModal
                centered
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
            >
                <Modal.Body>
                    <img src={Success} alt='success' className='success-img' />

                    <h1>{t('reports.paymentRequestPopUp.thanksTitle')}</h1>
                    <h4>{t('reports.paymentRequestPopUp.requestTitle')}</h4>
                </Modal.Body>
            </StyledDebtModal>

            <WarningLetterModal
                show={sendLetterModal}
                onHide={hideSendLetterModal}
                checkboxes={letterCheckboxes}
                setCheckboxes={setLetterCheckboxes}
                onSend={sendWarningLetterFromModal}
            />

            <CommentsModal
                show={commentsModalOpened}
                buildingId={currentBuilding}
                onModalHide={closeModal}
                apartmentNum={currentAptNumber}
                showApartmentSelector={false}
            />

            {showSendToAllModal && (
                <SendToAllModal
                    onSendAllModalHide={onSendAllModalHide}
                    ltr={ltr}
                    title={title}
                    buildingID={buildingID}
                    apartmentTenantList={apartmentTenantList}
                    buildingAddress={buildingAddress}
                />
            )}

            {
                selectedRow.apartmentNumber && (
                    <WarningLetterNew
                        row={selectedRow}
                        clearSelectedRow={() => setSelectedRow({})}
                        currency={currency}
                        getWarningLetter={getWarningLetter}
                        downloadLetter={downloadLetter}
                        setDownload={setDownloadLetter}
                    />
                )
            }
        </StyledDebtList>
    );
}
